// presets do seletor de período. Ficam fora do componente porque o store
// também precisa deles: um preset salvo ("Últimos 30 dias") é recalculado ao
// reabrir a tela, em vez de reaplicar as datas congeladas do dia em que foi salvo.
export function localISO(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

function addDays(n) {
  const d = new Date();
  d.setDate(d.getDate() + n);
  return localISO(d);
}

function startOfWeek(date) {
  const d = new Date(date);
  d.setDate(d.getDate() - d.getDay());
  return d;
}

function endOfMonth(date) {
  return new Date(date.getFullYear(), date.getMonth() + 1, 0);
}

function startOfQuarter(date) {
  const q = Math.floor(date.getMonth() / 3);
  return new Date(date.getFullYear(), q * 3, 1);
}

function endOfQuarter(date) {
  const q = Math.floor(date.getMonth() / 3);
  return new Date(date.getFullYear(), q * 3 + 3, 0);
}

export function getPresetRange(key) {
  const now = new Date();
  const today = localISO(now);
  switch (key) {
    case 'today':
      return { from: today, to: today };
    case 'yest': {
      const d = addDays(-1);
      return { from: d, to: d };
    }
    case 'l7':
      return { from: addDays(-6), to: today };
    case 'l15':
      return { from: addDays(-14), to: today };
    case 'l30':
      return { from: addDays(-29), to: today };
    case 'l90':
      return { from: addDays(-89), to: today };
    case 'l180':
      return { from: addDays(-179), to: today };
    case 'l360':
      return { from: addDays(-359), to: today };
    case 'all':
      return { from: '2000-01-01', to: today };
    case 'tw':
      return { from: localISO(startOfWeek(now)), to: today };
    case 'lw': {
      const s = startOfWeek(
        new Date(now.getFullYear(), now.getMonth(), now.getDate() - 7)
      );
      const e = new Date(s);
      e.setDate(s.getDate() + 6);
      return { from: localISO(s), to: localISO(e) };
    }
    case 'tm':
      return {
        from: localISO(new Date(now.getFullYear(), now.getMonth(), 1)),
        to: today,
      };
    case 'lm': {
      const f = new Date(now.getFullYear(), now.getMonth() - 1, 1);
      return { from: localISO(f), to: localISO(endOfMonth(f)) };
    }
    case 'tq':
      return { from: localISO(startOfQuarter(now)), to: today };
    case 'lq': {
      const f = startOfQuarter(
        new Date(now.getFullYear(), now.getMonth() - 3, 1)
      );
      return { from: localISO(f), to: localISO(endOfQuarter(f)) };
    }
    case 'ty':
      return { from: `${now.getFullYear()}-01-01`, to: today };
    case 'ly':
      return {
        from: `${now.getFullYear() - 1}-01-01`,
        to: `${now.getFullYear() - 1}-12-31`,
      };
    default:
      return null;
  }
}
